import { render } from "./Svg.vue?vue&type=template&id=95182d8a&scoped=true&ts=true"
import script from "./Svg.ts?vue&type=script&lang=ts"
export * from "./Svg.ts?vue&type=script&lang=ts"

import "./Svg.pcss?vue&type=style&index=0&id=95182d8a&scoped=true&lang=postcss"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95182d8a"]])

export default __exports__